import React from "react";
import { useUggRouting } from "@ugitgud/legos/context/routing";
import { useBanner } from "@ugitgud/legos/hooks/useBanner";
import classNames from "classnames";

export const BannerContainer: React.FC<{
  ctaId: string;
  open?: boolean;
  children: (props: { open?: boolean; onClick: (url: string) => void; onClose: () => void }) => React.ReactElement;
  className?: string;
}> = ({ children, ctaId, open: openProp, className }) => {
  const { push } = useUggRouting();
  const { open: hookOpen, setBannerOpen } = useBanner(ctaId);

  const open = typeof openProp === "undefined" ? hookOpen : openProp;

  return (
    <div
      className={classNames(className, "overflow-y-hidden", {
        "transition-[height] !h-0": !open,
      })}
    >
      {children({
        open,
        onClick: (url) => {
          push(url);
        },
        onClose: () => setBannerOpen(false),
      })}
    </div>
  );
};
